module.exports = __webpack_public_path__ + "img/22.d1085c23.png";